import React, { useEffect, useRef, useState } from "react";
import useModal from "../../hooks/useModal";
import { OptionsIcon } from "../../../assets/icons";
import "./Options.css";
import { Popover } from "react-tiny-popover";


const Options = ({
  IconOption = OptionsIcon,
  options = [],
  style = {},
  type = "",
  positions = ['left', 'right']
}) => {

  const [refOptions, isShowOptions, setIsShowOptions] = useModal(false);
  const refOptContend = useRef(null)
  let width = 0;
  const [optWidth, setOptWidth] = useState(0)
  useEffect(() => {
    if (refOptContend.current) {
      setOptWidth(refOptContend.current.getBoundingClientRect().width);
    }
    return () => {

    }
  }, [isShowOptions, refOptContend.current])


  return (
    <div
      style={style}
      onClick={(e) => { setIsShowOptions(true) }}
      className={`content-options-component ${type}`}
    >

      <Popover
        containerStyle={
          {
            zIndex: 3000
          }
        }
        onClickOutside={() => setIsShowOptions(false)}
        isOpen={isShowOptions}
        reposition={true}
        positions={positions} // preferred positions by priority
        content={({ position, childRect, popoverRect }) => (


          <div ref={refOptContend} className="options-component">
            {options.filter(opt => typeof opt != "boolean").filter(opt => opt != undefined).map((option, index) => (
              <div key={index} className="options-component-option" onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setIsShowOptions(false)
                option.onClick(e);
              }}>{option.text}</div>
            ))}
          </div>

        )}
      /*  <div ref={refOptContend} className="options-component123">
     {options.map((option, index) => (
       <div key={index} className="options-component-option" onClick={(e) => { option.onClick(e); }}>{option.text}</div>
     ))}
   </div> 
     }*/
      ><div onClick={() => setIsShowOptions(!isShowOptions)}><IconOption width="5px" className={`icon-options ${type} animate__animated animate__bounceIn`} /></div></Popover>


      {/* {isShowOptions && options.length > 0 && (
          <div ref={refOptContend} className="options-component" style={{
               position: "fixed",
               top: refOptions.current.getBoundingClientRect().y,
             left: refOptions.current.getBoundingClientRect().x-optWidth,
            width: "fit-content"
          }} >
            {options.map((option, index) => (
              <div key={index} className="options-component-option" onClick={(e) => { option.onClick(e); setIsShowOptions(false); }}>{option.text}</div>
            ))}
          </div>
        )}  */}

    </div >
  );
};

export default Options;
